import { render, staticRenderFns } from "./UnIssue.vue?vue&type=template&id=2bff80e4"
import script from "./UnIssue.vue?vue&type=script&lang=js"
export * from "./UnIssue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports